"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const antd_1 = require("antd");
exports.ServiceButton = (0, styled_components_1.default)(antd_1.Button) `
  border-radius: 30px;
  height: 40px;
  width: 130px;
  background-color: #ffffff;
  border: none;
`;
